import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNocompare = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 19 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.32 2c4.36 0 7.897 3.206 7.897 7.16s-3.536 7.16-7.897 7.16c-4.362 0-7.898-3.206-7.898-7.16S4.958 2 9.32 2zM4.972 4.56c-1.43 1.11-2.335 2.76-2.335 4.6 0 3.346 2.992 6.058 6.683 6.058 1.148 0 2.229-.262 3.173-.725L4.783 4.31zM9.32 3.101c-1.21 0-2.345.291-3.324.801l7.781 10.28-.242-.322c1.505-1.11 2.467-2.804 2.467-4.701 0-3.346-2.992-6.058-6.682-6.058z",
		fill: "#FFF",
		fillRule: "evenodd"
	})
});
export default SvgNocompare;
